/** Known board tags — matches club thread API validation and redesign mockup. */
export const BOARD_TAG_KEYS = [
  'announcement',
  'general',
  'scouting',
  'harvest',
  'maintenance',
  'food_plot',
];

const TAG_CONFIG = {
  announcement: { label: 'Announcement', className: 'club-board-tag--announcement' },
  general: { label: 'General', className: 'club-board-tag--general' },
  scouting: { label: 'Scouting', className: 'club-board-tag--scouting' },
  harvest: { label: 'Harvest', className: 'club-board-tag--harvest' },
  maintenance: { label: 'Maintenance', className: 'club-board-tag--maintenance' },
  food_plot: { label: 'Food Plot', className: 'club-board-tag--food_plot' },
};

export function getBoardTagConfig(tag) {
  const key = (tag || '').trim().toLowerCase();
  if (TAG_CONFIG[key]) return { key, ...TAG_CONFIG[key] };
  const label = key
    ? key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
    : 'General';
  return { key: key || 'general', label, className: 'club-board-tag--custom' };
}

export function getBoardPrimaryTag(tags = []) {
  const list = Array.isArray(tags) ? tags : [];
  const known = list.find((t) => BOARD_TAG_KEYS.includes((t || '').toLowerCase()));
  return known || list[0] || 'general';
}
